import { DeviceType } from '@sky-uk-ott/client-lib-js-device';
import { SHAKA_PLAYER_VERSION_DEFAULT, ShakaPlayerVersion } from '../../internal-config';
// Internal Config
// Client Config when Remote Config is disabled
export function adaptShakaClientConfig() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, device = arguments.length > 1 ? arguments[1] : void 0;
    var _config_defaultConfig = config.defaultConfig, defaultConfig = _config_defaultConfig === void 0 ? {} : _config_defaultConfig, _config_clientConfig = config.clientConfig, clientConfig = _config_clientConfig === void 0 ? {} : _config_clientConfig;
    var _clientConfig_shakaPlayerVersion, _ref;
    return {
        internalRetryConfig: {
            maxRetryAttempts: clientConfig.maxRetryAttempts,
            retryCooloffTimeMinutes: clientConfig.retryCooloffTimeMinutes
        },
        shakaPlayerVersion: (_ref = (_clientConfig_shakaPlayerVersion = clientConfig.shakaPlayerVersion) !== null && _clientConfig_shakaPlayerVersion !== void 0 ? _clientConfig_shakaPlayerVersion : defaultConfig.shakaPlayerVersion) !== null && _ref !== void 0 ? _ref : getShakaPlayerVersionDefaultForDevice(device),
        useMuxJS: clientConfig.useMuxJS,
        vptAbr: clientConfig.vptAbr,
        nativeConfig: undefined,
        esVersion: clientConfig.esVersion,
        useDebug: clientConfig.useDebug,
        shakaTimeoutPolicy: clientConfig.shakaTimeoutPolicy,
        startAtSegmentBoundary: clientConfig.startAtSegmentBoundary,
        useMseOnSafari: clientConfig.useMseOnSafari,
        smoothCodecSwitch: clientConfig.smoothCodecSwitch,
        liveSync: clientConfig.liveSync,
        vodDynamicPlaybackRate: clientConfig.vodDynamicPlaybackRate,
        postAdBreakCorrectiveSeek: defaultConfig.postAdBreakCorrectiveSeek,
        seeker: defaultConfig.seeker,
        deferMultiviewSetAudioTrackWhileLoading: defaultConfig.deferMultiviewSetAudioTrackWhileLoading
    };
}
// Server Config when Remote Config is enabled
// Client Config when Remote Config is enabled
export function adaptShakaRemoteConfigSplit(config, device) {
    var _config_remoteConfig = config.remoteConfig, remoteConfig = _config_remoteConfig === void 0 ? {} : _config_remoteConfig;
    var _remoteConfig_shakaPlayerVersion;
    return {
        internalRetryConfig: remoteConfig.internalRetryConfig,
        shakaPlayerVersion: (_remoteConfig_shakaPlayerVersion = remoteConfig.shakaPlayerVersion) !== null && _remoteConfig_shakaPlayerVersion !== void 0 ? _remoteConfig_shakaPlayerVersion : getShakaPlayerVersionDefaultForDevice(device),
        useMuxJS: remoteConfig.useMuxJS,
        vptAbr: remoteConfig.vptAbr,
        nativeConfig: remoteConfig.nativeConfig,
        esVersion: remoteConfig.esVersion,
        useDebug: remoteConfig.useDebug,
        shakaTimeoutPolicy: remoteConfig.shakaTimeoutPolicy,
        startAtSegmentBoundary: remoteConfig.startAtSegmentBoundary,
        useMseOnSafari: remoteConfig.useMseOnSafari,
        smoothCodecSwitch: remoteConfig.smoothCodecSwitch,
        liveSync: remoteConfig.liveSync,
        vodDynamicPlaybackRate: remoteConfig.vodDynamicPlaybackRate,
        postAdBreakCorrectiveSeek: remoteConfig.postAdBreakCorrectiveSeek,
        seeker: remoteConfig.seeker,
        deferMultiviewSetAudioTrackWhileLoading: remoteConfig.deferMultiviewSetAudioTrackWhileLoading
    };
}
var getShakaPlayerVersionDefaultForDevice = function(device) {
    switch(device.type){
        case DeviceType.WebMaf:
            return ShakaPlayerVersion.V_3_0_5;
        default:
            return SHAKA_PLAYER_VERSION_DEFAULT;
    }
};

//# sourceMappingURL=shaka-config-adapter.js.map